document.addEventListener('DOMContentLoaded', function () {
  // 既存FAQ
  document.querySelectorAll('.hase-faq-q-box').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.closest('.hase-faq-item');
      if (!item) return;
      const answer = item.querySelector('.hase-faq-a-box');
      if (!answer) return;
      if (item.classList.contains('is-open')) {
        answer.style.maxHeight = '0px';
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 40 + 'px';
      }
    });
  });

  // 既存百科事典
  const encyclopediaTrigger = document.getElementById('juzuEncyclopediaTrigger');
  const encyclopediaBody = document.getElementById('juzuEncyclopediaBody');
  if (encyclopediaTrigger && encyclopediaBody) {
    encyclopediaTrigger.addEventListener('click', () => {
      encyclopediaTrigger.classList.toggle('is-active');
      encyclopediaBody.classList.toggle('is-open');
    });
  }

  // v3同様、文書座標で固定開始を判定。
  // FVにはclip-pathがあるため、fixed中だけbodyへ移して切り抜きを回避する。
  const quickNav = document.querySelector('.juzu-quick-nav');
  if (quickNav) {
    const originalParent = quickNav.parentNode;
    const spacer = document.createElement('div');
    spacer.className = 'juzu-quick-nav-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    originalParent.insertBefore(spacer, quickNav);
    let startY = 0;
    let expandedHeight = 0;
    let isFixed = false;

    function measure() {
      startY = spacer.getBoundingClientRect().top + window.scrollY;
      if (!isFixed) expandedHeight = quickNav.getBoundingClientRect().height;
    }
    function updateQuickNav() {
      const shouldFix = window.scrollY >= startY;
      if (shouldFix === isFixed) return;
      isFixed = shouldFix;
      if (isFixed) {
        spacer.style.height = expandedHeight + 'px';
        document.body.appendChild(quickNav);
        quickNav.classList.add('is-fixed', 'is-compact');
      } else {
        quickNav.classList.remove('is-fixed', 'is-compact');
        originalParent.insertBefore(quickNav, spacer.nextSibling);
        spacer.style.height = '0px';
      }
    }
    measure();
    window.addEventListener('scroll', updateQuickNav, { passive: true });
    window.addEventListener('resize', () => { measure(); updateQuickNav(); });
    window.addEventListener('load', () => { measure(); updateQuickNav(); });
    updateQuickNav();
  }

  // 既存data-targetスクロール。固定ナビに隠れないよう補正
  document.querySelectorAll('[data-target]').forEach(btn => {
    btn.style.cursor = 'pointer';
    btn.addEventListener('click', () => {
      const selector = btn.dataset.target;
      if (!selector) return;
      let target;
      try { target = document.querySelector(selector); } catch (e) { return; }
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY;
      const offset = quickNav ? (quickNav.classList.contains('is-compact') ? quickNav.offsetHeight : 64) : 0;
      window.scrollTo({ top: Math.max(0, top - offset), behavior: 'smooth' });
    });
  });
});
